function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinbase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z",
    fill: "#081327",
    style: {
      fill: "#081327",
      fill: "color(display-p3 0.0314 0.0745 0.1529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 16C23.5 20.1421 20.1421 23.5 16 23.5C11.8579 23.5 8.5 20.1421 8.5 16C8.5 11.8579 11.8579 8.5 16 8.5C20.1421 8.5 23.5 11.8579 23.5 16Z",
    fill: "#0052FF",
    style: {
      fill: "#0052FF",
      fill: "color(display-p3 0.0000 0.3216 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0094 18.5C14.6256 18.5 13.5047 17.3813 13.5047 16C13.5047 14.6187 14.6256 13.5 16.0094 13.5C17.2492 13.5 18.2782 14.4021 18.4765 15.5833H21C20.7871 13.0167 18.6351 11 16.0094 11C13.2438 11 11 13.2396 11 16C11 18.7604 13.2438 21 16.0094 21C18.6351 21 20.7871 18.9833 21 16.4167H18.4744C18.2761 17.5979 17.2492 18.5 16.0094 18.5Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "border",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31ZM16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#576085",
    fillOpacity: 0.4,
    style: {
      fill: "#576085",
      fill: "color(display-p3 0.3412 0.3765 0.5216)",
      fillOpacity: 0.4
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinbase);
export default __webpack_public_path__ + "static/media/coinbase.2cede465fdbdd5b4853396152abd9d7c.svg";
export { ForwardRef as ReactComponent };